/*
  This file contains all project-related constants. Place here
  any constant that depends on an environment variable or global
  variables.
*/

const env = process.env.REACT_APP_ENV;
const environment = {
  isDevelopment: env === 'development',
  isStaging: env === 'staging',
  isProduction: env === 'production',
};

const constants = {
  baseUrl: process.env.REACT_APP_BASEURL,
  apiUrl: process.env.REACT_APP_API_URL,
  secondaryApiUrl: process.env.REACT_APP_ALTERNATIVE_API_URL,
  newApiUrl: process.env.REACT_APP_NEW_API_URL,

  /*
    NOTE: be careful when changing these values, they are also coded
    in CSS.
  */
  breakpoints: {
    extraLargeMinWidth: 1500,

    largeMaxWidth: 1499,
    largeMinWidth: 1200,

    mediumMaxWidth: 1199,
    mediumMinWidth: 992,

    smallMaxWidth: 991,
    smallMinWidth: 768,

    extraSmallMaxWidth: 767,
    extraSmallMinWidth: 576,

    mobileThreshold: 575,
  },

  contactPhoneNumber: {
    text: '2902 7737',
    value: '29027737',
  },

  dateLocale: 'es',

  dateFormat: 'DD/MM/YYYY',

  enableMobxDevtools: process.env.REACT_APP_ENABLE_MOBX_DEVTOOLS === 'true',

  environment,
  environmentName: env,

  externalIntranetLink: 'http://intra.carlosgutierrez.com.uy',
  normalIntranetPath: '/show.asp?Articulo=',
  specificIntranetPath: '/show_especifico.asp?articulo=',

  googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || null,

  googleAnalytics4Id: process.env.REACT_APP_GOOGLE_ANALYTICS4_ID || null,

  googleMapsAPIKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,

  inputMaxLength: 180,

  phoneMaxLength: 20,

  installationTextCharacteristicId: '254',

  panavoxLigature: '_PANAVOX_',

  pixelDensity: window.devicePixelRatio || 1,

  recaptchaKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,

  rollbarToken: process.env.REACT_APP_ROLLBAR_TOKEN || null,

  ticketVerificationURL: 'http://www.panavox.com.uy/webcfe/cfe.aspx',

  version: process.env.REACT_APP_VERSION,

  contactMail: process.env.REACT_APP_CONTACT_EMAIL,

  refreshConfigParams: process.env.REACT_APP_REFRESH_PARAMS,

  activeCovid: false,

  productIdCreditCardTax: process.env.REACT_APP_PRODUCT_ID_DEBIT_CARD_TAX,
};

export { constants };



// WEBPACK FOOTER //
// ./src/config/constants.js